import type { User } from '../types';

export function canAccessAdmin(user: User | null | undefined): boolean {
  return user?.role === 'admin';
}

export function canAccessCustomerArea(user: User | null | undefined): boolean {
  if (!user) return false;
  if (user.role === 'admin') return true;
  return user.emailConfirmed;
}
